import Backbone from 'backbone';
import Form from './../base/form.js';
import CustomValidation from './../base/custom-validation.js';
import {
  convertTypeForService
} from './../base/phone.js';
import PhoneInput from '../components/phone-input.js';

let Utils = {
  applicationFlow: '',
  validPromotion: false,
  gdprAttributes: {
    preferences: '',
    optInEmailOffers: false,
    optInThirdPartyEmailOffers: false,
    countryCode: ''
  },
  emptyApp: function() {
    $('.app').empty();
  },
  isValid: function(model) {
    return model.isValid(true);
  },
  addInputError: function(attr) {
    let $input = $('[data-binding="' + attr + '"], [name="' + attr + '"]');
    if ($input.length > 0) {
      $input.parents('.form-group').addClass('has-error');
    }
  },
  removeInputError: function(attr) {
    let $input = $('[data-binding="' + attr + '"]:not(#confirmPassword), [name="' + attr + '"]:not(#confirmPassword)');
    if ($input.length > 0) {
      $input.parents('.form-group').removeClass('has-error');
    }
  },
  handleSubmitButton: function(model, el, e) {
    let errors = model.validate();

    if (_.keys(errors).length > 0) {
      Form.disableFormField(el);
    } else {
      Form.enableFormField(el);
    }
  },
  extendModelResponseData: function(model, response) {
    let obj = {};
    return _.extend(obj, model.attributes, response);
  },
  extendUserData: function(data) {
    if (window.App.Collections.Users.models[0]) {
      window.App.Collections.Users.models[0].set(data);
    }
  },
  getUserAttribute: function(attr) {
    return window.App.Collections.Users.models[0].get(attr);
  },
  setUserAttribute: function(attr, val) {
    return window.App.Collections.Users.models[0].set(attr, val);
  },
  scrollToTop: function() {
    $('html, body').animate({
      scrollTop: 0
    });
  },
  scrollToForm: function() {
    let top = $('.app form').offset().top - $('header:visible').height();
    $('html,body').animate({
      scrollTop: top
    });
  },
  nextStep: function(step) {
    if (step) {
      $('.wr-progress-tracker .progress-step:eq(' + step + ')').addClass('step-active');
      $('.wr-progress-tracker .progress-step:lt(' + step + ')').each((i, e) => {
        $(e).addClass('step-complete')
          .removeClass('step-active');
        $(e).find('.bubble-indicator')
          .remove('.wr-step-number')
          .html('<i class="progress-icon wr-icon-check"></i>');
      });
    }
  },
  triggerFormChecks: function() {
    $(document).trigger('checkEmptyInput');
  },
  bindDefaultValues: function(model, form) {
    let inputs = $(form).find('input, select');

    $(inputs).each((i, e) => {
      if ($(e).val()) {
        let inputId = $(e).attr('id');
        if (inputId === 'preferred' || inputId === 'preferredThirdParty') {
          this.setPreferredCheckbox(model, $(e));
        } else {
          this.setBindingAttribute(model, $(e));
        }
      }
    });
  },
  initLegalDiscalimerForApp: function(view) {
    let $disclaimer = Form.getDisclaimer(view.$('form'));
    if ($disclaimer && typeof $disclaimer === 'string') {
      $disclaimer = $(DOMPurify.sanitize($disclaimer));
      if ($disclaimer.length) {
        let inputBindingValue = this.getInputBindingValue($disclaimer);
        if (inputBindingValue) {
          _.extend(view.model.validation, {
            [inputBindingValue]: {
              acceptance: true
            }
          });
        }
      }
    }
  },
  setPreferredCheckbox: function(model, el) {
    let attr = $(el).data('binding'),
      checked = $(el)[0].checked;

    if (!checked) {
      model.set(attr, 'Unacceptable');
    } else {
      model.set(attr, 'Preferred');
    }
  },
  setPreferredCheckboxValue: function(model, id, checked) {
    let attr = null;

    if (id === 'preferred') {
      attr = 'Preferences.0.PreferLevel';
    } else if (id === 'preferredThirdParty') {
      attr = 'Preferences.2.PreferLevel';
    }

    if (attr) {
      if (!checked) {
        model.set(attr, 'Unacceptable');
      } else {
        model.set(attr, 'Preferred');
      }
    }
  },
  setGdprAttributes: function(name, val) {
    this.gdprAttributes[name] = val;
  },
  getGdprAttributes: function(name) {
    return this.gdprAttributes[name];
  },
  getGdprObjFtsi: function() {
    return {
      country: this.getUserAttribute('country'),
      optInEmailOffers: this.getUserAttribute('optInEmailOffers'),
      optInThirdPartyEmailOffers: this.getUserAttribute('optInThirdPartyEmailOffers'),
    };
  },
  getGdprObjEnroll: function() {
    return {
      country: this.getGdprAttributes('countryCode'),
      optInEmailOffers: this.getGdprAttributes('optInEmailOffers'),
      optInThirdPartyEmailOffers: this.getGdprAttributes('optInThirdPartyEmailOffers')
    };
  },
  disableSubmit: function() {
    $('#submit').attr('disabled', true);
  },
  enableSubmit: function() {
    $('#submit').attr('disabled', false);
  },
  getInputBindingValue: function(input) {
    let $input = $(input);
    return $input.data('binding') || $input.attr('name');
  },
  setBindingAttribute: function(model, e) {
    let $input = e.currentTarget ? $(e.currentTarget) : $(e),
      attr = this.getInputBindingValue($input),
      val = $input.val();

    if ($input.is('input[type="checkbox"]')) {
      val = $input.prop('checked');
    }

    if (attr.indexOf('.PhoneType') > -1) {
      attr = attr.replace('.PhoneType', '');
      val = _.extend({}, model.get(attr), convertTypeForService(val));
    }

    if (e.type === 'focusout') {
      $input.addClass('touched');
    }

    model.set(attr, val);
  },
  validateBindingAttribute: function(model, e) {
    if (e.type !== 'focusin') {
      let inputs = $(e.currentTarget).closest('form')
          .find('input, select'),
        errors = model.validate();

      inputs.each((i, e) => {
        let $input = $(e),
          name = $input.attr('data-binding') || $input.attr('name');

        if ($input.hasClass('touched')) {
          if (this.inputHasError(name, errors)) {
            this.addInputError(name);
          } else {
            this.removeInputError(name);
          }
        }
      });
    }
  },
  inputHasError: function(name, errors) {
    if (!errors || errors.length < 1) {
      return false;
    }

    // PhoneType is purley a UI value that represents the combintation of
    // the PhoneTechType and PhoneLocationType values.
    let phoneTypeIndex = name.indexOf('PhoneType');
    if (phoneTypeIndex > -1) {
      name = name.substring(0, phoneTypeIndex);
      return name + 'PhoneTechType' in errors || name + 'PhoneLocationType' in errors;
    }

    return name in errors;
  },
  countryRequiresZipcode: function(countryCode) {
    return /^US|CA|MX|UK|GB$/i.test(countryCode);
  },
  localeRequiresZipcode: function(locale) {
    return /^EN-US|EN-UK|EN-GB|EN-CA|FR-CA$/i.test(locale);
  },
  toggleBussinessEnrollmentDropdown: function($btCheckbox) {
    Form.toggleBussinessEnrollmentDropdown($btCheckbox);
  },
  updateBusinessEnrollmentPayload(model) {
    if ($('.business-enrollment-wrapper').length > 0) {
      let $beCheckbox = $('#businessEnrollmentCheckbox');
      let $beSelect = $('#businessEnrollmentSelect');
      let beValue = $beCheckbox.is(':checked') ? $beSelect.val() : '';
      model.set({'preferences': {'BUSTRAVTYPE': beValue}});
      model.unset('preferences.businessEnrollmentCheckbox');
    }
  },
  deletePiplPayload(model) {
    if ($('.separate-consent-wrapper').length > 0) {
      model.unset('SeparateConsent');
      model.unset('separateConsentCheckbox');
    }
  },
  captureBusinessEnrollmentAnalytics() {
    let $beCheckbox = $('#businessEnrollmentCheckbox');
    let $beSelect = $('#businessEnrollmentSelect');
    if ($beCheckbox && $beCheckbox.length > 0 && $beCheckbox.is(':checked')) {
      let $optionSelected = $beSelect.find('option:selected');
      let customerType = $optionSelected.data('originalText') || $optionSelected.text();
      //Set dataLayer
      if(customerType && window.digitalData && window.digitalData.page  && window.digitalData.page.pageInfo) {
        window.digitalData.page.pageInfo.customerType = customerType;
        //Notify Analytics
        if (typeof window._satellite !== 'undefined') {
          window._satellite.track('businessTravelerView');
        }
      }
    }
  },
  bindBackboneValidation: function(backboneView) {
    Backbone.Validation.bind(backboneView);
  },
  extendBackboneValidation: function() {
    _.extend(Backbone.Validation.validators, {
      zipCodeValidation: (value, attr, customValue, model) => {
        if (this.countryRequiresZipcode(model.get('addresses.0.countryCode')) && value && (value.length < 5 || value.length > 12)) {
          return true;
        }
      },
      nameAndCityValidation: (value, attr, customValue, model) => {
        if (value) {
          let validationExp = /^(?![\s])[a-zA-Z0-9\s-']*$/;
          if (!validationExp.test(value)) {
            return true;
          }
        }
      },
      memberNumberValidation: (value, attr, customValue, model) => {
        if (value) {
          let validationExp = /[0-9]{9}[a-z A-Z]{1}/;
          if (!validationExp.test(value)) {
            return true;
          }
        }
      },
      phoneNumberValidation: (value, attr, customValue, model) => {
        if (value) {
          const countryCode = PhoneInput.getPhoneNumberCountryByIndex(0);
          let newPhoneNumber = value;
          if (countryCode && newPhoneNumber.startsWith(countryCode)) {
            newPhoneNumber = newPhoneNumber.slice(countryCode.length);
          }
          const parsed = newPhoneNumber.match(/(\d)/g);
          if (!/^\+?[\d\s\-\(\)\.]*$/i.test(value) || (parsed && (parsed.length < 6 || parsed.length > 18))) {
            return true;
          }
        }
      },
      notEqual: (value, attr, customValue, model) => {
        if (value === model.get(customValue)) {
          return true;
        }
      },
      passwordValidation: (value, attr, customValue, model) => {
        if (!CustomValidation.passwordLengthRule(value) || !CustomValidation.passwordNumberRule(value) || !CustomValidation.passwordAlphaRule(value)) {
          return true;
        }
      },
      usernameValidation: (value, attr, customValue, model) => {
        if (!CustomValidation.usernameLengthRule(value) || !CustomValidation.usernameCharactersRule(value)) {
          return true;
        }
      },
      confirmPasswordValidation: (value, attr, customValue, model) => {
        return true;
      }
    });
  },
  destroyStep: function(view) {
    if (view) {
      view.undelegateEvents();
      view.unbind();
    }
  },
  destroy: function(view) {
    if (view) {
      view.undelegateEvents();
      view.remove();
      view.unbind();
    }
  }
};

export default Utils;
